// extracted by mini-css-extract-plugin
export var boldCellText = "b69e010581fd8d96ba75e756ed191ba7-css";